import { joinURL } from "ufo";
import { createOperationsGenerator } from "#image";
const operationsGenerator = createOperationsGenerator({
  keyMap: {
    fit: "func",
    format: "force_format",
    quality: "q",
    width: "w",
    height: "h"
  },
  valueMap: {
    fit: {
      cover: "crop",
      contain: "fit",
      fill: "cover",
      inside: "bound",
      outside: "boundmin"
    }
  },
  joinWith: "&",
  formatter: (key, value) => `${key}=${value}`
});
export const getImage = (src, { modifiers = {}, baseURL } = {}) => {
  if (!baseURL) {
    console.warn(`[filerobot] <baseURL> is required to build image URL`);
  }
  const operations = operationsGenerator(modifiers);
  const query = operations ? "?" + operations : "";
  return {
    url: joinURL(baseURL, src) + query
  };
};
